import { render, staticRenderFns } from "./TestMode.vue?vue&type=template&id=5a5109b9&scoped=true&"
import script from "./TestMode.vue?vue&type=script&lang=js&"
export * from "./TestMode.vue?vue&type=script&lang=js&"
import style0 from "./TestMode.vue?vue&type=style&index=0&id=5a5109b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5109b9",
  null
  
)

export default component.exports